<template>
  <div>
    <v-container>
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" lg="4">
            <trans-textbox
              v-model="item"
              :label="$t('globals.name')"
              :rules="[$rules.required]"
              :disabled="disabled"
              field="Name"
              class="required"
            ></trans-textbox>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" lg="4">
            <no-autocomplete-textfield
              v-model="item.Number"
              :label="$t('globals.number')"
              :disabled="disabled"
              :rules="[
                $rules.alphanumeric,
                $rules.dynamic.upToLength(5),
                $rules.unionLocalNumberZeros,
                rules.unique,
                $rules.required,
              ]"
              class="required"
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" lg="4">
            <no-autocomplete-textfield
              v-model="item.PhoneNumber"
              :label="$t('globals.telephone')"
              :rules="[rules.phone]"
              v-mask="telephoneMask"
              :disabled="disabled"
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" lg="4">
            <no-autocomplete-textfield
              v-model="item.Fax"
              :label="$t('globals.fax_number')"
              :rules="[rules.phone]"
              v-mask="telephoneMask"
              :disabled="disabled"
            ></no-autocomplete-textfield>
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="4">
            <no-autocomplete-textfield
              v-model="item.Email"
              :label="$t('headers.contacts.email')"
              :rules="[$rules.email]"
              :disabled="disabled"
            ></no-autocomplete-textfield>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <!-- <address-form
      ref="address"
      :provinces="options.Models.Province"
      :item="item"
      v-if="item"
      @valid="addressValid = $event"
    ></address-form> -->
    <span class="text-h6 ml-1">
      {{ $t("globals.address") }}
    </span>
    <canada-post-address
      :address="item.Address"
      @update-address="item.Address = $event"
      @valid="validAddress=$event"
    />
    <contacts
      ref="contactsTable"
      @contacts-changed="item.Contacts = $event"
      :contacts="item.Contacts"
      identifier="localsEditContactsPlanBuilder"
      :planIdentityId="planIdentityId"
    ></contacts>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TransTextbox from "@/components/TransTextbox.vue";
// import AddressForm from "@/components/AddressForm.vue";
import Contacts from "./Contacts.vue";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield.vue";
import { mask, tokens } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import { translate2 } from "@/trans2";
import CanadaPostAddress from "@/components/CanadaPostAddress";
export default {
  components: {
    TransTextbox,
    CanadaPostAddress,
    Contacts,
    NoAutocompleteTextfield,
  },
  props: ["item", "disabled", "planIdentityId", "union", "locals"],
  directives: { mask },
  mounted() {},
  data() {
    return {
      valid: false,
      telephoneMask: "(###) ### - ####",
      rules: {
        phone: (v) => {
          let val = this.unmask(v, this.telephoneMask);
          return !val || this.$rules.phone(val);
        },
        unique: (v) => {
          console.log("unique validation", this.isNumberUnique);
          return (
            (this.locals.filter(
              (o) =>
                o.Identifier !== this.item.Identifier &&
                o.Number === this.item.Number
            ).length === 0 &&
              this.isNumberUnique) ||
            this.$t("validation.unique_number")
          );
        },
      },
      isNumberUnique: true,
      uniqueNumberMonitor: null,
      validAddress:true
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    valid: {
      handler(v) {
        this.$emit("valid-changed", v && this.validAddress);
      },
      immediate: true,
    },
    validAddress: {
      handler(v) {
        this.$emit("valid-changed", v && this.valid);
      },
      immediate: true,
    },
    "item.Number": {
      async handler(v) {
        console.log("number is :", v, this.item, this.union);
        if (v === null) {
          return;
        }
        const obj = {};
        this.uniqueNumberMonitor = obj;
        await this.delay(800);
        if (this.uniqueNumberMonitor !== obj) {
          return;
        }
        // try {
        const payload = {
          UnionName: this.union.Name,
          TradeCode: this.union.TradeCode,
          Name: translate2(this.item, "Name"),
          Number: this.item.Number,
        };
        console.log(payload);
        this.isNumberUnique = (await this.checkUnionLocalNumberUnique({
          planIdentityId: this.planIdentityId,
          payload: payload,
        })).data;

        console.log("response is: ", this.isNumberUnique);
        this.$refs.form.validate();
        // } catch (error) {
        //   this.error = error;
        // }
      },
    },
    "item.Name": {
      async handler(v) {
        if (this.item.Number === null || this.item.Number === undefined) {
          return;
        }
        console.log("number is :", v, this.item, this.union);
        if (v === null) {
          return;
        }
        const obj = {};
        this.uniqueNumberMonitor = obj;
        await this.delay(800);
        if (this.uniqueNumberMonitor !== obj) {
          return;
        }
        // try {
        const payload = {
          UnionName: this.union.Name,
          TradeCode: this.union.TradeCode,
          Name: translate2(this.item, "Name"),
          Number: this.item.Number,
        };
        // console.log(payload);
        this.isNumberUnique = (await this.checkUnionLocalNumberUnique({
          planIdentityId: this.planIdentityId,
          payload: payload,
        })).data;
        this.$refs.form.validate();
        // console.log("response is: ", resp);
        // } catch (error) {
        //   console.error(error);
        // }
      },
    },
  },
  methods: {
    ...mapActions("plansMembers", ["checkUnionLocalNumberUnique"]),
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    isValid() {
      //console.log(this.valid)
      return this.valid && this.validAddress;
    },
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style></style>
